import { config } from '../config'
import Vue from 'vue'
import Notify from 'utils/notify'

let sessionHasExpired = false

Vue.http.interceptors.push((request, next) => {
	next((response) => {
		if (response.status === 401 && !sessionHasExpired && store.state.user.authorized) {
			sessionHasExpired = true

			Notify.error('Your session has expired, please login again.');

			setTimeout(() => {
				sessionStorage.removeItem('token');
				this.$store.dispatch(types.SET_AUTHORIZED, false);
				this.$router.go({ name: 'dashboard' });
			}, 2000)
		}
	});
});



// WEBPACK FOOTER //
// ./src/interceptors/unauthorized.js